<template>
<div>
  <section class="firstSection">
    <b-container fluid class="bestPos pb-4">
      <b-row align-v="center" class="marginLeft">
        <b-col sm class="mt-3">
          <h1 class="h4">Your clients need affordable instant financing</h1><br />
          <h2 class="title">Increase traffic and business <br />by a click of a button</h2>
          <p class="mt-4">
Simplified payment approval process for you and your customers.
          </p>
        </b-col>
        <b-col sm>
          <img src="../assets/images/color/color-3/vendormain.png" class="img-fluid">
        </b-col>
      </b-row>
      <b-row>
        <b-col class="4">
        </b-col>
        <b-col class="col-4">
          <b-button lg="4" size="lg" pill variant="outline-danger" class="buttonlearn" @click="scrollTo()">Sign Up</b-button>

        <!-- <b-button lg="4" size="lg" pill variant="outline-danger" class="buttonlearn" :to="{ name: 'ForVendors', hash: '#signUp' }">Sign Up</b-button> -->
</b-col>
<b-col class="4">
</b-col>
      </b-row>
    </b-container>
  </section>
  <div class="container">
      <!-- Three columns of text below the carousel -->
      <div class="row">
        <div class="col-lg-4">
          <img class="center img-fluid" src="../assets/images/color/color-3/customer-care.svg" v-bind="mainPropsTransparency" rounded="circle" alt="Circle image">
          <h2 class="mt-3 text-center">O% - 14.9% interest!</h2>
          <p>Gone are days your client need to empty their bank account to get their vehicle back in the road.</p>
        </div><!-- /.col-lg-4 -->
        <div class="col-lg-4">
          <img class="center img-fluid" src="../assets/images/color/color-3/Salesfunnel.svg" v-bind="mainPropsTransparency" rounded="circle" alt="Circle image">
          <h2 class="mt-3 text-center">Increased Sales</h2>
          <p>Our flexible payment plans will not only grow your monthly revenue with your direct clients, You are also Gaining access to thousands of potential customers reaching our platfrom every month.</p>
        </div><!-- /.col-lg-4 -->
        <div class="col-lg-4">
          <img class="center text-center img-fluid" src="../assets/images/color/color-3/mcspeed.svg" v-bind="mainPropsEfficiency" rounded="circle" alt="Circle image">
          <h2 class="mt-3 text-center">Speed</h2>
          <p>No forms to fill, your clients only need to provide the make/model/year of the vehicle, phone number and their email. Your client can be approved in less than 5 minutes!</p>
        </div><!-- /.col-lg-4 -->
      </div><!-- /.row -->


      <!-- START THE FEATURETTES -->

      <hr class="featurette-divider">

      <div class="row featurette mt-5" ref="features">
        <div class="col-md-7 mt-5">
          <h2 class="featurette-heading">Your Vendor dashboard <span class="text-muted">enables you to manage all your client</span></h2>
          <p class="lead">The system is designed for mechanics, access our App on your phone. A client needs a payment plan? Upload images of the vehicle and that's it!</p>
        </div>
        <div class="col-md-5">
          <img src="../assets/images/color/color-3/monitormc.png" class="img-fluid lgimages">

  <!-- <b-img src="../assets/images/color/color-3/monitor.jpg" fluid-grow alt="Fluid-grow image"></b-img>
          <svg class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" width="500" height="500" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><title>Car repair</title><rect width="100%" height="100%" fill="#eee"></rect><text x="50%" y="50%" fill="#aaa" dy=".3em">500x500</text></svg> -->
        </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette mt-5">
        <div class="col-md-7 order-md-2 mt-5">
          <h2 class="featurette-heading">No credit checks <span class="text-muted">or income verfication</span></h2>
          <p class="lead">Our AI based system enables us to approve 87.6% of the applications!</p>
        </div>
        <div class="col-md-5 order-md-1">
          <img src="../assets/images/color/color-3/paymentplan.png" class="img-fluid lgimages">

        </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette mt-5">
        <div class="col-md-7 mt-5">
          <h2 class="featurette-heading">Speedy<span class="text-muted"> Service</span></h2>
          <p class="lead">Our account manages are at your service anytime with phone support from 8:00AM till 20:00PM.</p>
        </div>
        <div class="col-md-5">
          <img src="../assets/images/color/color-3/speedfly.png" class="img-fluid lgimages">

        </div>
      </div>

      <hr class="featurette-divider">

      <!-- /END THE FEATURETTES -->

    </div>

<div id="anchorName2" >
<vendorSignUp />
</div>

</div>
</template>

<script>
export default {
  name: 'ForVendors',
  data(){
    return {
            mainPropsSupport: { blank: false, blankColor: '#777', width: 150, height: 150, class: 'm1' },
            mainPropsTransparency: { blank: true, blankColor: '#777', width: 150, height: 150, class: 'm1' },
            mainPropsEfficiency: { blank: true, blankColor: '#777', width: 150, height: 150, class: 'm1' }
          }
  },

  mounted() {
    document.querySelector('.navbar').classList.add('darkHeader')
  },
  methods: {
scrollTo() {
  var element_to_scroll_to = document.getElementById('anchorName2');
element_to_scroll_to.scrollIntoView();
},
}
}

</script>

<style scoped>


@media (max-width: 576px) {
  img.lgimages {
        width: 400px;
    }
    .bestPos{
      padding-top: 3rem;
    }
    .marginLeft{
      margin-left: 10px;
    }
  }


// Medium devices (tablets, 768px and up)
@media (max-width: 768px) {
  img.lgimages {
        width: 250px;
    }
    .marginLeft{
      margin-left: 90px;
    }

  }
  html {
    scroll-behavior: smooth;
  }
// Large devices (desktops, 992px and up)
@media (max-width: 992px) {   img.lgimages {
        width: 700px;
    }
    .marginLeft{
      margin-left: 90px;
    }
  }


// Extra large devices (large desktops, 1200px and up)
@media (max-width: 1200px) {   img.lgimages {
        width: 700px;
    }
    .marginLeft{
      margin-left: 90px;
    }
  }
.buttonlearn{
color: white;

}
.buttonlearn:hover {
  background-color: #40c991;
}
.firstSection{
  padding-bottom: 10px;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.container {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.box {
  padding: 2rem;
  border-top: 3px solid #40c991;
}

select,
input {
  border-radius: 1rem;
  max-width: 350px;
  margin: 1.5rem auto 0 auto;
}

select:focus,
input:focus {
  box-shadow: none;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}
h1{
  font-size: 3rem;
  font-weight: normal !important;
  color: #FFFFFF ;
}

h2.title{
  font-size: 2rem;
  font-weight: bold;
  color: #F15B22 ;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #7b7e7d;
}

.awesome {
  color: #40c991;
}
/* Resets */
hr {
  margin-left: 0;
  max-width: 40px;
}
.bestPos{
  background-color: black;
}

/* Jumbotron (hero) */
.jumbotron {
  position: relative;
  background: url(../assets/images/color/color-3/team-bg.png) no-repeat bottom center / cover;
  padding-top: 10%;

  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }

  .container {
    padding: 0px 0;
  }

  h1,
  .lead {
    color: #fff;
  }
}

/* Bustom button */
.btn-primary {
  background: #1096fc;
  border: 0;

  &:hover {
    background: darken(#1096fc, 7%);
  }
}

/* Features */
.sec-features {
  .row {
    &:nth-of-type(n+2) {
      margin-top: 160px;
    }

    &:last-of-type {
      margin-bottom: 160px;
    }
  }

  .feature-icon {
    max-width: 150px;
  }
}

/* Testimonials */
.sec-testimonials {
  padding-top: 128px;
  padding-bottom: 128px;
}

/* Carousel */
.carousel-indicators {
  bottom: -30px;

  li {
    background: rgba(33, 33, 33, .1);

    &:focus,
    &:hover {
      background: rgba(33, 33, 33, .5);
    }
  }

  .active {
    background: rgba(33, 33, 33, .75);
  }
}

.carousel-control-next,
.carousel-control-prev {
  & {
    color: #212121;
  }

  &:focus,
  &:hover {
    color: #111;
  }
}

/* Footer */
.footer {
  padding-top: 24px;
  padding-bottom: 24px;
  background: #212121;

  li {
    &:nth-of-type(n+2) {
      margin-left: 8px;
    }
  }

  a {
    font-size: 18px;
    color: rgba(255, 255, 255, .5);
    transition: color .235s ease-in-out;

    &:focus,
    &:hover {
      color: rgba(255, 255, 255, .25);
    }
  }
  #nav {
  position: fixed;
  top: 0;
  left: 0;
  background: #333;
  margin: 0;
  padding: 15px;
  list-style: none;
  border-radius: 0 0 10px 0;
  box-shadow: 0 0 8px rgba(0,0,0,0.6);
}

#nav a {
  display: block;
  padding: 10px 10px;
  color: #fff;
}

#nav a:hover {
  color: #ff0;
}

.section {
  height: 1000px;
  padding: 30px 140px;
}

#section-1 {
  background: #eee;
}

#section-2 {
  background: #ddd;
}

#section-3 {
  background: #ccc;
}

h1 {
  margin: 0 0 20px 0;
}

.section a {
  color: #3399FF;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/forvendors.vue